export default __webpack_public_path__ + "static/media/skills-light.ec4aa833.svg";